module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-72x72-43e2586d198a8959e3dab2b984aff7d5.png";